import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";
import { IndicatorCell } from "../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";

const useAccumulatorOverrideSchedule = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialSelectMode = false,
  initialLookupType,
  selectModeParamData = {}
) => {
  const [data, setData] = useState([]);
  const { axios_helper_no_header } = useAxios();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const [hideFlag, setHideFlag] = useState(false);
  const toast = useToast();
  const location = useLocation();
  const {
    ADD_ACCUMULATOR_OVERRIDE_SCHEDULE,
    ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
    COPY_ACCUMULATOR_OVERRIDE_SCHEDULE,
    ACCUMULATOR_OVERRIDE_SCHEDULE_NOTE,
  } = ROUTE_PATHS;

  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [disabledDropdowns, setDisabledDropdowns] = useState([]);

  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSchedules = [],
    selectedCodesListItem = "",
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      aosAccumOvrdSchedule: "",
      hiddenRecordIndicator: "Active",
    },
  } = currentState;

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState({
    ...initialParamsData,
    ...(selectMode ? { aosAccumOvrdScdeType: "E" } : {}),
  });

  const screen_title = "Accumulator Override Schedule";
  const screenNumber = selectMode ? "RCAOS006" : "RCAOS001";
  const statusKey = "aosDispOutdatedRcds";

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]
      ?.aosAccumOvrdSchedule;
  const updatedParamsData = {
    ...paramsData,
    aosAccumOvrdSchedule: lastScheduleName,
  };

  const formFields = selectMode
    ? [
        {
          fieldLabel: "AOS Accum Ovrd Schedule",
          name: "aosAccumOvrdSchedule",
          label: "Schedule",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 15,
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          fieldNature: "editable",
          value: "",
          maxLength: 1,
        },
      ]
    : [
        {
          fieldLabel: "AOS Accum Ovrd Schedule",
          name: "aosAccumOvrdSchedule",
          label: "Schedule",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 15,
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          fieldNature: "editable",
          value: "",
          maxLength: 1,
        },
      ];

  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = () => {
    if (lookupType === "external") {
      const message = { type: "hideModal" };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Accumulator Override Schedule",
          button_handeler: () => {
            navigateToPage("/add-accumulator-override-schedule", [
              { previousScreen: location.pathname },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const menuOptions = selectMode
    ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramDataMap = new Map();
            selectParams.forEach(key => {
              if (rowData.hasOwnProperty(key["target"])) {
                paramDataMap.set(key["source"], rowData[key["target"]]);
              }
            });
            const paramData = Object.fromEntries(paramDataMap);
            if (lookupType !== "external") {
              onSelect(paramData);
            } else {
              const message = {
                type: "responseData",
                data: paramData,
              };
              window.parent.postMessage(message, "*");
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            /* navigateToPage("/display-accumulator-override-schedule", [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);*/
            const params = selectParams || [];
            const paramData = params.reduce((acc, item) => {
              if (rowData.hasOwnProperty(item["target"])) {
                acc[item["target"]] = rowData[item["target"]];
              }
              return acc;
            }, {});
            const message = {
              type: "navigateData",
              data: paramData,
              target: "OVERRIDE_SCHEDULE_READ_ONLY",
            };
            console.log("display message", message);
            window.parent.postMessage(message, "*");
          },
        },
        {
          label: "Criteria",
          icon: <span className="material-icons">filter_list</span>,
          command: () => {
            /* navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);*/
            const params = selectParams || [];
            const paramData = params.reduce((acc, item) => {
              if (rowData.hasOwnProperty(item["target"])) {
                acc[item["target"]] = rowData[item["target"]];
              }
              return acc;
            }, {});
            const message = {
              type: "navigateData",
              data: paramData,
              target: "OVERRIDE_SCHEDULE_CRITERIA",
            };
            console.log("criteria message", message);
            window.parent.postMessage(message, "*");
          },
        },
      ]
    : [
        {
          label: "Note",
          icon: <span className="material-icons">note</span>,
          command: () => {
            navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_NOTE, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedPriceSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage("/edit-accumulator-override-schedule", [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Copy",
          icon: <span className="material-icons">content_copy</span>,
          command: () => {
            navigateToPage(COPY_ACCUMULATOR_OVERRIDE_SCHEDULE, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedPriceSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage("/display-accumulator-override-schedule", [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Criteria",
          icon: <span className="material-icons">filter_list</span>,
          command: () => {
            navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: rowData[statusKey] === "Hidden" ? "Unhide" : "Hide",
          icon: <span className="material-icons">visibility_off</span>,
          command: () => {
            openHideConfirmationModal();
          },
        },
      ];

  const columnDef = selectMode
    ? [
        {
          header: "Schedule",
          field: "aosAccumOvrdSchedule",
        },
        {
          header: "Description",
          field: "aosAccumOvrdScdeDesc",
        },
        {
          header: "Type",
          field: "aosAccumOvrdScdeType",
          style: { width: "5%" },
        },
      ]
    : [
        {
          header: "Schedule",
          field: "aosAccumOvrdSchedule",
        },
        {
          header: "Description",
          field: "aosAccumOvrdScdeDesc",
        },
        {
          header: "Type",
          field: "aosAccumOvrdScdeType",
          style: { width: "5%" },
        },
        {
          header: "Indicators",
          field: "noteExistenceStatus",
          body: (rowData) => (
            <IndicatorCell
              rowData={rowData}
              fields={[
                "noteExistenceStatus",
                "schdOverrideIndicator",
              ]}
              tooltipContent={{
                noteExistenceStatus: "Notes",
                schdOverrideIndicator: "State Schedule Override"
              }}
            />
          ),
        },
        // {
        //   header: "",
        //   field: "schdOverrideIndicator",

        // },
        {
          header: "Status",
          field: "aosDispOutdatedRcds",
          style: { width: "5%" },
        },
      ];

  const parmKey = "aosAccumOvrdSchedule";

  const hideSchedule = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        aosAccumOvrdSchedule: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header(
        "PUT",
        "api/aosaccumulatorovrdscde/hideUnhide",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error updating the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  const fetchData = async () => {
    const page = first / rows;
    let queryParams = {
      page: page,
      size: rows,
      ...paramsData,
    };
    //params required for lookup screen RCAOS006
    queryParams.aosAccumOvrdScdeType = paramsData?.aosAccumOvrdScdeType || "";
    queryParams.hiddenRecordIndicator = paramsData?.hiddenRecordIndicator || "";
    //In some cases initially select mode is undefined. Hence lookup params
    //not getting sent.
    if (selectMode !== undefined && !selectMode) {
      queryParams = {
        page: page,
        size: rows,
        ...paramsData,
      };
    }
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/aosaccumulatorovrdscde`,
        null,
        queryParams
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);

      if (selectMode) {
        const filteredValues = response[
          "Hidden Record IndicatorValid Values"
        ].filter((item) => item.value !== "H" && item.value !== "A");
        setDropdownValues({
          "Hidden Record IndicatorValid Values": filteredValues,
        });
      } else {
        setDropdownValues(response);
      }
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, [selectMode]);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, selectMode, lookupType]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const deleteAccumulatorOverrideSchedule = () => {
    if (selectedOption === "yes") {
      const params = { aosAccumOvrdSchedule: rowData[parmKey] };
      axios_helper_no_header(
        "DELETE",
        "api/aosaccumulatorovrdscde",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setData(updatedItems);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          fetchData();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    let queryParams = {
      ...paramsData,
      screenNumber: screenNumber,
    };
    //params required for lookup screen RCAOS006
    queryParams.aosAccumOvrdScdeType = paramsData?.aosAccumOvrdScdeType || "E";
    queryParams.hiddenRecordIndicator = paramsData?.hiddenRecordIndicator || "";
    //In some cases initially select mode is undefined. Hence lookup params
    //not getting sent.
    if (selectMode !== undefined && !selectMode) {
      queryParams = {
        ...paramsData,
        screenNumber: screenNumber,
      };
    }
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/aosaccumulatorovrdscde/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      setLookupType("external");
      setSelectParams(paramData.params);
      setParamsData({
        ...paramsData,
        aosAccumOvrdSchedule: paramData?.paramsData?.aosAccumOvrdSchedule || "",
        aosAccumOvrdScdeType: paramData?.paramsData?.aosAccumOvrdScdeType || "",
      });
      setSelectMode(selectMode);
      setDisabledDropdowns({ hiddenRecordIndicator: true });
      //setSelectModeData()
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteAccumulatorOverrideSchedule,
    setSelectedOption,
    hideSchedule,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    leftButtons,
    selectMode,
    disabledDropdowns,
  };
};

export default useAccumulatorOverrideSchedule;